


































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../../shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import {ExpenseCustomer} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import moment from 'moment';
import {FORMAT_DATE_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import {ExpenseCustomerStore} from '../../../store';
import {ClearingDebtType} from "@/enums/type";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

const columns = [
    {
        title: "STT",
        dataIndex: "stt",
        key: "stt",
        width: 80
    },
    {
        title: "Ngày phát hành",
        dataIndex: "billLading.ladingDate",
        key: "ladingDate",
        width: 150,
        ellipsis: true,
        scopedSlots: {customRender: 'ladingDate'}
    },
    {
        title: "Mã vận đơn",
        dataIndex: "billLading.ladingCode",
        key: "ladingCode",
        width: 150,
        ellipsis: true
    },
    {
        title: "Thu hộ",
        dataIndex: "billLading.codMoney",
        key: "codMoney",
        scopedSlots: {customRender: 'codMoney'},
        width: 150,
        ellipsis: true
    },
    {
        title: "Cước cấn trừ",
        dataIndex: "clearingMoney",
        key: "clearingMoney",
        scopedSlots: {customRender: 'clearingMoney'},
        width: 120,
        ellipsis: true
    },
    {
        title: "Trạng thái vận đơn",
        dataIndex: "billLading.status",
        key: "statusBillLading",
        scopedSlots: {customRender: 'statusBillLading'},
        width: 180,
        ellipsis: true
    },
    {
        title: "Khách hàng",
        dataIndex: "customer.customerCode",
        key: "customer",
        width: 170,
        ellipsis: true,
        scopedSlots: {customRender: "customer"}
    },
    {
        title: "TT.Thu tiền",
        dataIndex: "billLading.collectDelivery",
        key: "collectDelivery",
        scopedSlots: {customRender: "collectDelivery"},
        width: 120,
        ellipsis: true
    },
    {
      title: "Ngày thu tiền",
      dataIndex: "billLading.payCollectUpdateBy",
      key: "collectDeliveryDate",
      scopedSlots: {customRender: "collectDeliveryDate"},
      width: 150,
      ellipsis: true
    }
];
@Component({
    name: "ExpenseCustomerTable",
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly creditCustomers!: Array<ExpenseCustomer>;
    columns = columns;
    moment = moment;
    FormatDate = FORMAT_DATE_PICKER;
    clearingType = ClearingDebtType

    get pagination() {
        return {
            current: ExpenseCustomerStore.meta.page,
            pageSize: ExpenseCustomerStore.meta.limit,
            total: ExpenseCustomerStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} bản ghi`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePage(pagination: any) {
        ExpenseCustomerStore.updateParamsExpenseCustomer({
            ...ExpenseCustomerStore.params,
            page: pagination.current,
            limit: pagination.pageSize
        })
        ExpenseCustomerStore.listCreditCustomer(ExpenseCustomerStore.params);
    }

  clearingMoneyExpense(record) {
    return record.clearingType !== ClearingDebtType.Yes ? (record.clearingMoney ? record.clearingMoney : 0) : 0
  }
}
